import React, { useLayoutEffect, useState } from "react";
import { TheContent, TheSidebar, TheFooter, TheHeader } from "./index";
import MenuContext from "src/_components/ContextAPI";
import { apiCallSPGet } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import cgmfRoutes from "src/routes";

const TheLayout = () => {
  const { authenticated } = Auth();
  const [data, setData] = useState(null);
  const [menuRouteListData, setMenuRouteListData] = useState(null);
  const [cgmfRouteListData, setcgmfRouteListData] = useState(null);

  const getAPIDataToObject = async (apiResponse) => {
    const result = await apiResponse.reduce((acc, item) => {
      if (item.parentId === 0) {
        // It's a top-level item
        acc.push({
          id: item.rightsId,
          _tag: item.tag,
          name: item.title,
          route: item.route,
          icon: item.icon,
          _children: [],
        });
      } else {
        // It's a child item, find its parent and add it to _children
        const parent = acc.find(
          (parentItem) => parseInt(parentItem.id) === parseInt(item.parentId)
        );

        if (parent) {
          parent._children.push({
            _tag: item.tag,
            name: item.title,
            to: item.toURL,
          });
        }
      }
      return acc;
    }, []);

    // If you need to perform further transformation using map
    const finalResult = result.map((parentItem) => {
      // Potentially transform each parentItem if necessary
      return {
        ...parentItem,
        _children: parentItem._children.map((child) => ({
          ...child,
          // Any additional transformation on child if necessary
        })),
      };
    });

    return finalResult;
  };
  const getAllRights = async () => {
    if (authenticated && authenticated.roleMasterId > 0) {
      await apiCallSPGet(
        `RoleRights?roleMasterId=${authenticated.roleMasterId}`
      )
        .then(async (res) => {
          //alert("call");
          setMenuRouteListData(res.data);
          const DataSet = await getAPIDataToObject(res.data);
          setData(DataSet);
          //console.log("TheLayout cgmfRoutes : ", cgmfRoutes);

          const matched = res.data.filter((apiItem) =>
            cgmfRoutes.some(
              (existingItem) => existingItem.accessKey === apiItem.accessKey
            )
          );
          //console.log("TheLayout matched : ", matched);
          setcgmfRouteListData(matched);
          //alert("call");
        })
        .catch((error) => console.error("Error fetching data:", error));
    }
  };
  useLayoutEffect(() => {
    // Fetch data from API

    getAllRights();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  return (
    <MenuContext.Provider
      value={{
        menuList: data,
        menuRouteList: menuRouteListData,
        cgmfRouteListData: cgmfRouteListData,
      }}
    >
      {/* //&& data !== null  */}
      {authenticated && (
        <div className="c-app c-default-layout">
          <TheSidebar />
          <div className="c-wrapper ">
            <TheHeader />
            <div className="c-body">
              <TheContent />
            </div>
            <TheFooter />
          </div>
        </div>
      )}
    </MenuContext.Provider>
  );
};

export default TheLayout;
